import React from 'react';
import Reviews from '../reviews/Reviews';
export default function ReviewsPage(){ return <Reviews />; }
